import { gql } from '@apollo/client'

export const PREVIEW_USER_CONVERSATION_MESSAGE = gql`
  mutation previewUserConversationMessage($kind: ChatConversationMessageTemplateKind!) {
    previewUserConversationMessage(kind: $kind) {
      value
    }
  }
`
